module.exports = __webpack_public_path__ + "assets/img/a3e01ee5ec6e867fbaaaaf44d92491e5.svg";